module.exports = __webpack_public_path__ + "7d199acd6f52396377e6c2989aaccb74.svg";